import React from "react";
import { Flame } from "lucide-react";

/**
 * Minimal editorial pull-quote divider between Experience (03) and Guesthouse (04).
 * Hairline + flame icon + short serif italic quote. Compact, no scrolling.
 */
export default function TransitionQuote() {
  return (
    <div
      data-testid="transition-quote"
      className="relative bg-white py-14 sm:py-20"
    >
      <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
        {/* Hairline + flame */}
        <div className="flex items-center justify-center gap-4">
          <span className="block w-16 sm:w-28 h-px bg-gradient-to-r from-transparent to-pkred/45" />
          <Flame
            className="w-4 h-4 sm:w-[18px] sm:h-[18px] text-pkred drop-shadow-[0_0_10px_rgba(217,4,41,0.55)]"
            fill="currentColor"
            strokeWidth={1.3}
          />
          <span className="block w-16 sm:w-28 h-px bg-gradient-to-l from-transparent to-pkred/45" />
        </div>

        <p className="font-serif italic text-pkcharcoal/85 text-2xl sm:text-3xl lg:text-[2rem] leading-snug mt-7 font-light">
          „A tűz nem főz — <span className="text-pkred">mesél.</span>”
        </p>

        <div className="mt-5 flex items-center justify-center gap-3 text-[0.65rem] tracking-[0.35em] uppercase text-pkcharcoal/45 font-semibold">
          <span className="block w-6 h-px bg-pkcharcoal/25" />
          A házigazdák
        </div>
      </div>
    </div>
  );
}
